"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecommendationsGamesByCategories = void 0;
var useQuery_1 = require("../useQuery");
var keys_1 = require("../keys");
var user_1 = require("../user");
var react_1 = require("react");
var geo_1 = require("../geo");
var currencies_1 = require("../currencies");
var game_api_1 = require("@l2p/game-api");
var useRecommendationsGamesByCategories = function () {
    var _a;
    var isAuth = (0, user_1.useIsAuthorized)();
    var geoData = (0, geo_1.useGeo)().data;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.GAMES_RECOMMENDATIONS_BY_CATEGORIES,
        canRender: !!(isAuth && geoData && currentCurrency),
        revalidateOnMount: true,
        payload: {
            country: (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode,
            currency: currentCurrency,
            categories: [
                game_api_1.UserRecommendationsEnum.RecommendedGames,
                game_api_1.UserRecommendationsEnum.Trending,
                game_api_1.UserRecommendationsEnum.New,
            ],
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, isValidating = _b.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data === null || data === void 0 ? void 0 : data.data, isLoading, isValidating, error]);
};
exports.useRecommendationsGamesByCategories = useRecommendationsGamesByCategories;
